// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/admin/background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 0 0;
  background-size: 100%;
}
.admin .admin-header {
  padding: 3% 6% 5%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.admin .admin-header .menu-logo {
  width: 21%;
}
.admin .admin-header .config {
  width: 9%;
  cursor: pointer;
}
.admin .welcome {
  font: 2.7em/1 vigaregular;
  color: #fff;
  margin: 6%;
  text-align: center;
}
.admin .admin-list {
  margin: 0 6%;
  padding: 6% 0;
}
.admin .admin-list .title {
  background-color: #caa36c;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  padding: 5% 6%;
  display: flex;
}
.admin .admin-list .title h2 {
  font: 2.2em/1 vigaregular;
  color: #fff;
}
.admin .admin-list .content {
  background-color: #fff;
  text-align: center;
}
.admin .admin-list .content ul {
  padding: 4% 4% 0 4%;
  min-height: 312px;
}
.admin .admin-list .content ul li {
  background: #f2f2f2;
  border-bottom: 1px solid #f2f2f2;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4%;
  padding: 10px 5px;
  text-align: left;
}
.admin .admin-list .content ul li:last-child {
  border-bottom: none;
}
.admin .admin-list .content ul li h3 {
  font: 1.4em/1 vigaregular;
  flex-grow: 1;
}
.admin .admin-list .content ul li h3 a {
  text-decoration: none;
  color: #5c5c5c;
  display: block;
  padding: 10px;
}
.admin .admin-list .content ul li .actions {
  display: flex;
  justify-content: flex-end;
}
.admin .admin-list .content ul li .actions a, .admin .admin-list .content ul li .actions div {
  cursor: pointer;
  padding: 0 8px;
}
.admin .admin-list .content ul li .actions a span, .admin .admin-list .content ul li .actions div span {
  color: #5C5C5C;
  font-size: 16px;
}
.admin .admin-list .content ul li .actions a img, .admin .admin-list .content ul li .actions div img {
  width: 100%;
  max-width: 18px;
}
.admin .admin-list .content .bottom-buttons {
  display: block;
  text-align: center;
  width: 100%;
  padding-bottom: 4%;
}
.admin .admin-list .content .add {
  align-items: center;
  border: 1px solid #caa36a;
  border-radius: 10px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  margin: 0 4%;
  padding: 12px;
  text-decoration: none;
  cursor: pointer;
}
.admin .admin-list .content .add span {
  font: 1.3em/1 vigaregular;
  text-decoration: none;
  text-align: center;
  color: #5c5c5c;
}
.admin .admin-list .content .add span.icon-add {
  font-size: 1.7em;
}
.admin .admin-list .content .add img {
  margin-left: 5px;
  max-width: 17px;
}
.admin .admin-list footer {
  display: flex;
}
.admin .admin-list footer:before {
  content: "";
  height: 20px;
  background-color: #fff;
  width: calc(100% - 20px);
}
.admin .admin-list footer:after {
  width: 0;
  height: 0;
  content: "";
  border-top: 20px solid #dbdbdb;
  border-right: 20px solid transparent;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/Admin.scss","webpack://./src/styles/core/3colors.scss"],"names":[],"mappings":"AAEA;EACI,iEAAA;EACA,qBAAA;AADJ;AAGI;EACI,iBAAA;EAEA,aAAA;EACA,8BAAA;EACA,mBAAA;AAFR;AAIQ;EACI,UAAA;AAFZ;AAKQ;EACI,SAAA;EACA,eAAA;AAHZ;AAOI;EACI,yBAAA;EACA,WCbQ;EDcR,UAAA;EACA,kBAAA;AALR;AAQI;EACI,YAAA;EACA,aAAA;AANR;AAQQ;EACI,yBAAA;EACA,2BAAA;EACA,4BAAA;EACA,cAAA;EACA,aAAA;AANZ;AAQY;EACI,yBAAA;EACA,WC/BA;ADyBhB;AAUQ;EACI,sBCpCI;EDqCJ,kBAAA;AARZ;AAUY;EACI,mBAAA;EACA,iBAAA;AARhB;AAUgB;EACI,mBAAA;EACA,gCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AARpB;AAUoB;EACI,mBAAA;AARxB;AAWoB;EACI,yBAAA;EACA,YAAA;AATxB;AAWwB;EACI,qBAAA;EACA,cC9Df;ED+De,cAAA;EACA,aAAA;AAT5B;AAaoB;EACI,aAAA;EACA,yBAAA;AAXxB;AAawB;EACI,eAAA;EACA,cAAA;AAX5B;AAY4B;EACI,cAAA;EACA,eAAA;AAVhC;AAY4B;EACI,WAAA;EACA,eAAA;AAVhC;AAiBY;EACI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AAfhB;AAiBY;EACI,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;AAfhB;AAiBgB;EACI,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,cC9GP;AD+Fb;AAkBgB;EACI,gBAAA;AAhBpB;AAmBgB;EACI,gBAAA;EACA,eAAA;AAjBpB;AAsBQ;EACI,aAAA;AApBZ;AAsBY;EACI,WAAA;EACA,YAAA;EACA,sBCpIA;EDqIA,wBAAA;AApBhB;AAuBY;EACI,QAAA;EACA,SAAA;EACA,WAAA;EACA,8BAAA;EACA,oCAAA;AArBhB","sourcesContent":["@import '../../../src/styles/core/3colors.scss';\n\n.admin {\n    background: url(../../../public/images/admin/background.png) no-repeat 0 0;\n    background-size: 100%;\n\n    .admin-header {\n        padding: 3% 6% 5%;\n\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n\n        .menu-logo {\n            width: 21%;\n        }\n\n        .config {\n            width: 9%;\n            cursor: pointer;\n        }\n    }\n\n    .welcome {\n        font: 2.7em/1 vigaregular;\n        color: $white-primary;\n        margin: 6%;\n        text-align: center;\n    }\n\n    .admin-list {\n        margin: 0 6%;\n        padding: 6% 0;\n\n        .title {\n            background-color: #caa36c;\n            border-top-left-radius: 5px;\n            border-top-right-radius: 5px;\n            padding: 5% 6%;\n            display: flex;\n\n            h2 {\n                font: 2.2em/1 vigaregular;\n                color: $white-primary;\n            }\n        }\n\n        .content {\n            background-color: $white-primary;\n            text-align: center;\n\n            ul {\n                padding: 4% 4% 0 4%;\n                min-height: 312px;\n\n                li {\n                    background: #f2f2f2;\n                    border-bottom: 1px solid $white-secundary;\n                    border-radius: 10px;\n                    display: flex;\n                    align-items: center;\n                    justify-content: space-between;\n                    margin-bottom: 4%;\n                    padding: 10px 5px;\n                    text-align: left;\n\n                    &:last-child {\n                        border-bottom: none;\n                    }\n\n                    h3 {\n                        font: 1.4em/1 vigaregular; \n                        flex-grow: 1;\n\n                        a {\n                            text-decoration: none;\n                            color: $black-grey;\n                            display: block;\n                            padding: 10px;\n                        }\n                    }\n\n                    .actions {\n                        display: flex;\n                        justify-content: flex-end;\n\n                        a, div {\n                            cursor: pointer;\n                            padding: 0 8px;\n                            span{\n                                color: #5C5C5C;\n                                font-size: 16px;\n                            }\n                            img {\n                                width: 100%;\n                                max-width: 18px;\n                            }\n                        }\n                    }\n                }\n            }\n\n            .bottom-buttons{\n                display: block;\n                text-align: center;\n                width: 100%;\n                padding-bottom: 4%;\n            }\n            .add {\n                align-items: center;\n                border: 1px solid #caa36a;\n                border-radius: 10px;\n                text-align: center;\n                display: flex;\n                justify-content: space-between;\n                margin: 0 4%;\n                padding: 12px;\n                text-decoration: none;\n                cursor: pointer;\n\n                span {\n                    font: 1.3em/1 vigaregular;\n                    text-decoration: none;\n                    text-align: center;\n                    color:$black-grey;\n                }\n                \n                span.icon-add{\n                    font-size: 1.7em;\n                }\n\n                img {\n                    margin-left: 5px;\n                    max-width: 17px;\n                }\n            }\n        }\n\n        footer {\n            display: flex;\n\n            &:before {\n                content: \"\";\n                height: 20px;\n                background-color: $white-primary;\n                width: calc(100% - 20px);\n            }\n\n            &:after {\n                width: 0;\n                height: 0;\n                content: \"\";\n                border-top: 20px solid #dbdbdb;\n                border-right: 20px solid transparent;\n            }\n        }\n    }\n}\n","$lemon-primary: #ffd100;\n$lemon-secondary: #a36829;\n\n$raspberry-primary: #e51e45;\n$raspberry-secondary: #a32941;\n\n$passion-primary: #c80084;\n$passion-secondary: #86316e;\n\n$tangerine-primary: #f3881e;\n$tangerine-secondary: #a34029;\n\n$white-primary: #fff;\n$white-secundary: #f2f2f2;\n$black-grey: #5c5c5c;\n$brown-primary: #caa36c;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
